import { default as judging } from ":src/modules/grading/judging/routes";
import { default as help } from ":src/modules/help-center/routes";
import { default as profile } from ":src/modules/profile/routes";
export default {
  BASE: "/judge",
  judging,
  help,
  profile,
};
